import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { connect } from "react-redux";

import styles from "./styles/Statistics.scss";
import { getStatistics } from "../../routes/Ad/ad.ducks";
import { getIconUrl } from "../../services/asset";
import { checkEmptyObject, formatNumber } from "../../services";

function Statistics({
  className,
  statistics,
  responsiveSetting,
  labels,
  icons,
  getStatistics
}) {
  useEffect(() => {
    if (!statistics || !checkEmptyObject(statistics)) {
      getStatistics();
    }
  }, []);

  const renderItem = (count: any, icon: any, text: any) => (
    <div className={styles.statisticItem}>
      <img className={styles.statisticIcon} alt={text} src={getIconUrl(icon)} />
      <div className={styles.statisticCount}>{formatNumber(count)}</div>
      <div className={styles.statisticText}>{text}</div>
    </div>
  );

  if (!statistics) {
    return null;
  }

  const {
    activeAdsCount,
    newActiveAdsCount,
    registeredUsersCount,
    tradesCount
  } = statistics;

  const { item } = responsiveSetting;

  return (
    <Row className={`${className} ${styles.container}`}>
      <Col {...item}>
        {renderItem(
          activeAdsCount,
          icons.activeAdsCount,
          labels.activeAdsCount
        )}
      </Col>
      <Col {...item}>
        {renderItem(tradesCount, icons.tradesCount, labels.tradesCount)}
      </Col>
      <Col {...item}>
        {renderItem(
          newActiveAdsCount,
          icons.newActiveAdsCount,
          labels.newActiveAdsCount
        )}
      </Col>
      <Col {...item}>
        {renderItem(
          registeredUsersCount,
          icons.registeredUsersCount,
          labels.registeredUsersCount
        )}
      </Col>
    </Row>
  );
}

Statistics.defaultProps = {
  responsiveSetting: {
    item: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6, xxl: 6 }
  },
  labels: {
    activeAdsCount: "Ukupno oglasa",
    newActiveAdsCount: "Novih oglasa",
    registeredUsersCount: "Registriranih korisnika",
    tradesCount: "Ukupno trgovina"
  },
  icons: {
    activeAdsCount: "total-ads.svg",
    newActiveAdsCount: "new-ads.svg",
    registeredUsersCount: "registered-users.svg",
    tradesCount: "total-trades.svg"
  },
  className: styles.statisticsSection
};

function mapStateToProps(state: any) {
  return {
    statistics: state.ad.statistics
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getStatistics: () => dispatch(getStatistics())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);



// WEBPACK FOOTER //
// ./src/containers/HomePage/Statistics.tsx